import React, {FC, JSXElementConstructor, PropsWithChildren} from 'react';

type Components = JSXElementConstructor<PropsWithChildren<any>>
    | [JSXElementConstructor<PropsWithChildren<any>>, {[key: string]: any}];

interface ProviderComposerProps {
    components: Components[];
}

const ProviderComposer: FC<ProviderComposerProps> = ({components, children}) => (
    <>
        {components.reverse().reduce((acc, curr) => {
            const [Provider, props] = Array.isArray(curr) ? [curr[0], curr[1]] : [curr, {}];
            return <Provider {...props}>{acc}</Provider>;
        }, children)}
    </>
);

export default ProviderComposer;
